var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"down-transform"}},[_c('div',{staticClass:"back-top",on:{"click":_vm.backTop}},[_c('i',{staticClass:"el-icon-arrow-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }